import React from "react"
import Pagination from "src/components/tailwind-components/Pagination"
import { PaginationInfo } from "src/components/tailwind-components/Pagination"
import { PartnerPreRegistrationTableRow } from "./PartnerPreRegistrationTableRow"
import { PartnerPreRegistrationSummary } from "../types"

interface PartnerPreRegistrationTableProps {
  partnerPreRegistrations: PartnerPreRegistrationSummary[]
  pagination: PaginationInfo
  onRevokeClick: (partnerPreRegistrationId: number) => void
  onReviveClick: (partnerPreRegistrationId: number) => void
  onPageChange: (page: number) => void
}

export const PartnerPreRegistrationTable: React.FC<PartnerPreRegistrationTableProps> = ({
  partnerPreRegistrations,
  pagination,
  onRevokeClick,
  onReviveClick,
  onPageChange,
}) => {
  if (partnerPreRegistrations.length === 0) {
    return (
      <div className="overflow-x-auto">
        <div className="flex items-center justify-center py-12 min-h-[360px]">
          <div className="text-gray-500">データがありません</div>
        </div>
      </div>
    )
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full table-fixed divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="w-[100px] px-4 py-3 text-center align-middle text-[14px] font-medium uppercase tracking-wider text-gray-500">
              ID
            </th>
            <th className="w-auto px-4 py-3 text-left align-middle text-[14px] font-medium uppercase tracking-wider text-gray-500">
              会社名
            </th>
            <th className="w-[150px] px-4 py-3 text-center align-middle text-[14px] font-medium uppercase tracking-wider text-gray-500">
              ステータス
            </th>
            <th className="w-[150px] px-4 py-3 text-center align-middle text-[14px] font-medium uppercase tracking-wider text-gray-500">
              申込日
            </th>
            <th className="w-[100px] px-4 py-3 text-center align-middle text-[14px] font-medium uppercase tracking-wider text-gray-500">
              {/* 編集ボタン用の空のヘッダー */}
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {partnerPreRegistrations.map((item) => (
            <PartnerPreRegistrationTableRow
              key={item.id}
              partnerPreRegistration={item}
              onRevokeClick={() => onRevokeClick(item.id)}
              onReviveClick={() => onReviveClick(item.id)}
            />
          ))}
        </tbody>
      </table>
      <div className="pb-8 pt-4">
        <Pagination pagination={pagination} onPageChange={onPageChange} />
      </div>
    </div>
  )
}
